import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {NovoCartaoComponent} from "../novo-cartao/novo-cartao.component";

import {ActivatedRoute, Router} from "@angular/router";
import {formatCurrency, formatNumber} from '@angular/common';
import {ContatosService} from "../services/contatos.service";
import {AutorizacaoService} from "../services/autorizacao.service";
import {ChartComponent} from "@progress/kendo-angular-charts";
import {VendasFidelidadeService} from "../services/vendas-fidelidade.service";
import {EnumTipoDeAcao} from "../../../server/lib/emun/EnumTipoDeAcao";
import {Observable, Subscription, timer} from "rxjs";
import {ConstantsService} from "../fidelidade/ConstantsService";
import {ContratoService} from "../superadmin/services/contrato.service";
import { EmpresasService } from '../superadmin/services/empresas.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { BotoesHomeComponent } from '../componentes/botoes-home/botoes-home.component';
import {CampanhaService} from "../services/campanha.service";
import {RotaGuardClient} from "../guards/auth-loja.guard";
import {DialogService} from "@progress/kendo-angular-dialog";
import {FidelidadeComponent} from "../fidelidade/fidelidade.component";
import {DeviceDetectorService} from "ngx-device-detector";
import {SocketService} from "../services/socket.service";
import {FaturaAbertaPagarComponent} from "../home/fatura-aberta-pagar/fatura-aberta-pagar.component";
import {AvisoAtualizacaoAtivoVM, AvisosAtualizacaoService} from "../services/avisos-atualizacao.service";
import {VendasPedidoService} from "../services/vendas-pedido.service";
import {MonitoradorPedidos} from "../fidelidade/MonitoradorPedidos";
import {EnumFiltroDePedidos, PedidosService} from "../services/pedidos.service";
import {StatusPedidoLabel} from "../../../server/lib/emun/EnumStatusPedido";
import {obtenhaRotaNovoPedidoLocal} from "../pedidos/pdv-local-config";
import {CaixaService} from "../pdv/services/caixa.service";
import {MesaService} from "../services/mesa.service";
import {PreferenciaHomeService} from "../services/preferencia-home.service";
import {EnumStatusPedido} from "../../../server/lib/emun/EnumStatusPedido";

/** Uma pendência do dia: contagem, texto pronto e para onde ir resolver. */
export interface PendenciaHome {
  id: string;
  texto: string;
  quantidade: number;
  rota: string;
  urgente: boolean;
}

/**
 * A leitura de um número do dia contra o mesmo ponto de ontem. `tom` é vazio
 * quando não há variação para exibir — aí sobra só o `texto`, de referência.
 */
export interface ComparativoHome {
  chip: string;
  tom: '' | 'alta' | 'baixa' | 'igual';
  texto: string;
}

export type PeriodoHome = 'hoje' | 'ontem' | '7dias' | '30dias' | 'mes';

/** Um recorte de vendas: o resumo do período, o período anterior equivalente e os produtos. */
export interface DadosPeriodoHome {
  resumo: any;
  anterior: any;
  produtos: any[];
  carregando: boolean;
  /** Dias do período no formato do resumo (DD/MM/YYYY), para desenhar dia sem venda como zero. */
  dias: string[];
  rotuloAnterior: string;
  /** Dias do período anterior, alinhados por posição com `dias`, para a segunda linha do gráfico. */
  diasAnterior: string[];
  /** Faturamento por hora (24 posições) do dia e do dia anterior; só para hoje/ontem. */
  horas: number[] | null;
  horasAnterior: number[] | null;
  /** Vendas por operador (quem fez ou aceitou o pedido). */
  operadores: any[];
  /**
   * Quebra por forma de pagamento. Vem de uma chamada própria (`agfp`): com
   * esse flag a SQL passa a somar `pagamento.valor` com INNER JOIN em
   * `pagamento_pedido`, o que tiraria do faturamento o pedido ainda não pago.
   * Por isso não pode ser a mesma chamada que alimenta o número principal.
   */
  formasDePagamento: any[];
}

export type DimensaoAnaliseHome = 'pagamento' | 'atendimento' | 'origem' | 'funcionario';

/** Uma parcela da composição do faturamento. */
export interface ParcelaFaturamentoHome {
  /** Identidade da parcela; é ela que escolhe a cor na barra e no ponto da lista. */
  chave: 'produtos' | 'entrega' | 'servico' | 'pagamento' | 'total' | 'descontos';
  rotulo: string;
  valor: number;
  sinal: 'base' | 'mais' | 'menos' | 'igual';
  detalhe?: string;
}

/** Linha de "por onde vendi": nome, total, quantidade e fatia do período. */
export interface LinhaDistribuicaoHome {
  nome: string;
  total: number;
  qtde: number;
  ticket: number;
  fatia: number;
}

/** Placar da fila de pedidos abertos, sem valor: é o que o operador olha primeiro. */
export interface FilaAgoraHome {
  novos: number;
  emPreparacao: number;
  prontos: number;
  saiuParaEntrega: number;
  entregueSemPagamento: number;
  /** Mesmo "Total" da aba Em aberto da tela de pedidos. */
  total: number;
  atrasados: number;
  minutosTolerancia: number;
  /** false = a loja nunca recebeu pedido: conta nova, divulgar o cardápio é o primeiro passo. */
  jaVendeu?: boolean;
  horario: string;
}

/** Uma célula da fila: rótulo, número e para onde ir quando clica. */
export interface CelulaFilaHome {
  id: string;
  rotulo: string;
  acao: string;
  /** O que o pedido está esperando nessa etapa: fecha a linha de baixo do card. */
  nota: string;
  quantidade: number;
  status: EnumStatusPedido | null;
  tom: 'novo' | 'neutro' | 'atrasado';
}

/**
 * Blocos da home. O perfil só decide a ORDEM; a permissão/módulo de cada bloco
 * decide se ele aparece. Nenhum bloco tem "if (dono)" dentro.
 */
export type BlocoHome = 'banner' | 'pendencias' | 'vendas' | 'vendasDetalhe' | 'fila' | 'atalhos' | 'pedidos' | 'cardapio' | 'fidelidade';

// Quem vê vendas entra pelo dinheiro inteiro — resumo e detalhe — antes da
// operação, no desktop e no celular (decisão do Márcio, 10/09/2026).
// Loja que já vendeu não recebe o card do cardápio: o link e o QR moram no
// banner. O card só existe para conta nova, onde é o primeiro passo.
const ORDEM_DONO: BlocoHome[] = ['banner', 'pendencias', 'vendas', 'vendasDetalhe', 'fila', 'pedidos', 'atalhos', 'fidelidade'];
const ORDEM_OPERADOR: BlocoHome[] = ['banner', 'pendencias', 'fila', 'atalhos', 'pedidos', 'fidelidade'];

// Conta que nunca vendeu: o cardápio/QR sobe para logo abaixo do banner, nos
// dois perfis. Para essa loja, divulgar o link É a tarefa do dia; a fila e as
// vendas ainda não existem. Assim que entra o primeiro pedido, volta ao normal.
const ORDEM_DONO_CONTA_NOVA: BlocoHome[] = ['banner', 'pendencias', 'cardapio', 'vendas', 'vendasDetalhe', 'fila', 'pedidos', 'atalhos', 'fidelidade'];
const ORDEM_OPERADOR_CONTA_NOVA: BlocoHome[] = ['banner', 'pendencias', 'cardapio', 'fila', 'atalhos', 'pedidos', 'fidelidade'];

/** Mesmo ponto de virada do SCSS: abaixo dele a home vira folha única. */
const LARGURA_ESTREITA = 575;

declare const _;

@Component({
  providers: [ ],
  selector: 'app-home-v2',
  templateUrl: './home-v2.component.html',
  styleUrls: ['./home-v2.component.scss'],

})
export class HomeV2Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(NovoCartaoComponent) dialogNovoCartao;
  @ViewChild(ChartComponent, {static: true})   chart;
  @ViewChild(FaturaAbertaPagarComponent, {static: false})   faturaAberta;
  @ViewChild('botoesHome', {static: false}) botoesHome: BotoesHomeComponent;
  resumo: any = {total: 0, qtdeAtivos: 0 , qtdeInativos: 0 };
  series: Observable<any>;
  seriesLabels: [] = [];
  graficos = ['dia' , 'mes' , 'ano' ];
  tipoGrafico ;
  ultimasAcoes: any = [];
  // A tabela de ações entra resumida; o lojista abre o resto se quiser.
  limiteAcoes = 10;
  exibirTodasAcoes = false;
  // O Kendo desenha os eixos com serifa por padrão; aqui usa a mesma fonte do painel.
  fonteGrafico = '11px "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, sans-serif';
  corRotuloGrafico = '#64748b';
  tipoDeAcaoEnum = EnumTipoDeAcao;
  resumoVenda: any = {
    total: 0, pontos: 0,  mesFormatado: 'Sem Vendas'
  };
  exibirFinanceiro = false;
  /** Valores e quantidades escondidos até o dono clicar no olho. A escolha
   *  fica só em memória (campo estático): trocar de tela e voltar mantém,
   *  mas F5 ou nova aba volta a esconder. Nada vai para storage. */
  valoresOcultos = true;
  private static valoresReveladosNestaAbertura = false;
  temModuloFidelidade = false;
  temModuloPedidos = false;
  temModuloMesas = false;
  podeOperarCaixa = false;
  filaAgora: FilaAgoraHome = null;
  private carregandoFila = false;
  /** Caixa e mesas: só o que o operador precisa saber de relance. */
  operacao: {caixa: any, mesas: any} = {caixa: undefined, mesas: undefined};
  private timerOperacao: any;
  usuario: any;
  empresa: any;
  /**
   * Vendas por período, todas do mesmo endpoint dos relatórios. "Hoje" compara
   * com ontem **até o mesmo horário** — o dia inteiro de ontem contra a manhã
   * de hoje acusaria queda toda manhã. Os outros comparam com o período
   * anterior equivalente.
   */
  periodos: {[chave: string]: DadosPeriodoHome} = {};
  horaResumoHoje = '';
  reabrindoLoja = false;
  filtroPeriodo: PeriodoHome = 'hoje';
  dimensaoAnalise: DimensaoAnaliseHome = 'pagamento';
  linkCopiado = false;
  /** QR ampliado por cima da página, aberto pelo botão do banner. */
  mostrarQrCode = false;
  qrcodeErro = false;
  private timerLinkCopiado: any;
  /** Os últimos pedidos do dia: a home responde "entrou pedido?" sem trocar de tela. */
  ultimosPedidos: any[] = [];
  carregandoUltimosPedidos = false;
  private timerResumoHoje: any;
  private assinaturaMonitorador: Subscription;
  private contagemNovosPedidos = -1;
  private pendenciasEmCache: PendenciaHome[] = [];
  private assinaturaPendencias = '';
  msg: any;
  novoPedido: any = {};
  carregou = false;
  fatura: any;
  fechouAlerta: Boolean;
  exibirModal: Boolean;
  exibirPedidos = false;
  marcando = false;
  msgStatus;
  total = 0;
  indice = 0;
  campanhasPendentes = [];
  isMobile: boolean;
  /** Celular ou janela estreita: manda na ordem dos blocos e no formato compacto. */
  telaEstreita = false;
  iframe: boolean;
  dialogWidth;
  avisosAtualizacaoDisponiveis: AvisoAtualizacaoAtivoVM[] = [];
  avisosAtualizacao: AvisoAtualizacaoAtivoVM[] = [];
  indiceAvisoAtualizacao = 0;
  exibirModalAvisosAtualizacao = false;
  carregandoAvisosAtualizacao = false;
  empresaCarregadaParaAvisosAtualizacao = false;
  faturaCarregadaParaAvisosAtualizacao = false;
  tentativaAutomaticaAvisosAtualizacao = false;
  avisosAtualizacaoPendentesPorConflito = false;
  private chaveSessaoAvisosAtualizacaoOcultos = 'promokit.avisosAtualizacao.ocultos';
  private chaveSessaoAvisosAtualizacaoVisualizados = 'promokit.avisosAtualizacao.visualizados';
  constructor(private router: Router,   private route: ActivatedRoute,
              private  contratoService: ContratoService,
              private autorizacaoService: AutorizacaoService , private vendasService: VendasFidelidadeService,
              private contatoService: ContatosService, private activatedRoute: ActivatedRoute,
              private dialogService: DialogService, private deviceService: DeviceDetectorService,
              private constantsService: ConstantsService, private empresasService: EmpresasService,
              private sanitizer: DomSanitizer, private campanhaService: CampanhaService,
              private avisosAtualizacaoService: AvisosAtualizacaoService,
              private vendasPedidoService: VendasPedidoService,
              private monitorador: MonitoradorPedidos,
              private pedidosService: PedidosService,
              private socketService: SocketService,
              private caixaService: CaixaService,
              private mesaService: MesaService,
              private preferenciaHome: PreferenciaHomeService,
              private casca: FidelidadeComponent) {
    this.isMobile = this.deviceService.isMobile()
    this.telaEstreita = this.isMobile || (typeof window !== 'undefined' && window.innerWidth <= LARGURA_ESTREITA);
    this.series = vendasService;
    this.tipoGrafico = this.graficos[0];
    let usuarioLogado = this.autorizacaoService.getUser();

    this.iframe = this.inIframe();

    if (usuarioLogado.garcom) {
      this.router.navigate(['/admin/pedidos-mesas'], {}).then(() => {
      });
      return
    }

    this.exibirFinanceiro = RotaGuardClient.visualizaRelatorios(usuarioLogado);
    this.podeOperarCaixa = RotaGuardClient.operarCaixa(usuarioLogado);
    this.constantsService.moduloPedido$.subscribe(data => {
      const jaTinhaModulo = this.temModuloPedidos;

      this.exibirPedidos = data;
      this.temModuloPedidos = !!data;

      if (this.temModuloPedidos && !jaTinhaModulo) {
        this.carregueUltimosPedidos();
        this.carregueFilaAgora();
      }
    });
    this.constantsService.moduloMesasGarcom$.subscribe(data => {
      const jaTinhaModulo = this.temModuloMesas;
      this.temModuloMesas = !!data;
      if (this.temModuloMesas && !jaTinhaModulo) this.carregueMesas();
    });
    // Precisa valer também para quem não vê relatórios: decide os blocos de fidelidade.
    this.constantsService.moduloFidelidade$.subscribe(data => this.temModuloFidelidade = !!data);

    // A faixa de pedidos pega carona na batida do monitorador, que já consulta o
    // servidor sozinho: nada de um segundo timer para dizer a mesma coisa. Fica
    // acima do corte de `exibirFinanceiro` de propósito — quem não vê dinheiro
    // ainda precisa ver pedido entrando (o valor é que some, no template).
    this.assinaturaMonitorador = this.monitorador.resumoPedidos$
      .subscribe(() => this.sincronizeUltimosPedidos());

    // Fila e operação valem para todo mundo, dono incluso: por isso a batida
    // delas fica antes do corte financeiro. Um minuto é o ritmo de quem está
    // no balcão; o placar do monitorador cobre o "pedido novo agora".
    this.carregueCaixa();
    this.timerOperacao = timer(1000 * 60, 1000 * 60).subscribe( () => {
      this.carregueFilaAgora();
      this.carregueCaixa();
      this.carregueMesas();
    });

    if (!this.exibirFinanceiro) return;

    this.carregueResumoHoje();
    this.carreguePeriodo('7dias');
    // Os pedidos entram o dia todo; sem isso a faixa congela no valor da abertura.
    // A lista pega carona: se um pedido for lido em outro aparelho o placar do
    // monitorador não muda, e sem esta batida ela envelheceria em silêncio.
    this.timerResumoHoje = timer(1000 * 120, 1000 * 120).subscribe( () => {
      this.carregueResumoHoje();
      this.carregueUltimosPedidos();
    });

    this.contatoService.obtenhaResumo({}).then(resumo => {
      this.resumo = resumo;
    });

    this.exibaGraficoDia();

    this.activatedRoute.queryParams.subscribe((queryParams: any) => {
      this.msg = queryParams.msg;
      this.novoPedido = {codigo: queryParams.codigo};
    });
    this.constantsService.moduloFidelidade$.subscribe(data => this.carregou = data != null);
    this.campanhaService.obtenhaCampanhas('', '', true).then( (respCampanhas: any) => {
      this.campanhasPendentes = respCampanhas.campanhas;
    });
    this.updateDialogWidth(window.innerWidth);
  }

  inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }


  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e.data.tipo === 'MENSAGEM_ADICIONAR_TAG') {
      if( e.data.fim ) {
        this.marcando = false;
      }

      this.total = e.data.total;
      this.indice = e.data.indice;
      this.msgStatus = this.sanitizer.bypassSecurityTrustHtml(e.data.msg);
    }
    else if( e.data.tipo === 'PKT_IMPORTE_CONTATOS' ) {
      this.msgStatus = this.sanitizer.bypassSecurityTrustHtml('Importando contatos...');

      const contatos = e.data.contatos;

      this.empresasService.importeContatos(this.empresa, contatos).then( (resp: any) => {
        this.botoesHome.terminouEnviarContatos();

        this.msgStatus = this.sanitizer.bypassSecurityTrustHtml(`<strong>Contatos Importados</strong>
<p class="mb-0">Novos: <strong>${resp.importados} contatos</strong></p>
<p>Existentes: <strong>${resp.existentes} contatos</strong></p>`);
      this.total = 100;
      this.indice = 100;
      }).catch( erro => {
        this.msgStatus = erro;
        this.botoesHome.terminouEnviarContatos();
      });
    }
  }

  private inscricaoLojaFechada: Subscription;

  ngOnInit() {
    this.valoresOcultos = !HomeV2Component.valoresReveladosNestaAbertura;
    // O modal de fechar loja é da casca; quando ele fecha a loja, o banner daqui
    // precisa refletir (mensagem de pausa, horários) sem recarregar a página.
    this.inscricaoLojaFechada = this.casca.lojaFechada.subscribe((result: any) => this.atualizeBannerAposFechar(result));
    this.atualizeTela();
    this.usuario = this.autorizacaoService.getUser() || {};
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if (!empresa) return;

      this.empresa = empresa;
      if (this.deveAbrirFilaSuporte()) {
        this.router.navigate(['/admin/suporte/fila']).then(() => {});
        return;
      }

      this.empresaCarregadaParaAvisosAtualizacao = true;
      this.carregueAvisosAtualizacaoSePossivel();
    });
    this.contratoService.obtenhaFaturaAberta().then( fatura => {
      const partesDataVencimento = String(fatura?.dataVencimento || '').split('/');
      const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      const numeroMes = Number(partesDataVencimento[1]);

      if(partesDataVencimento.length === 3 && meses[numeroMes - 1]) {
        const ano = partesDataVencimento[2].length === 2 ? `20${partesDataVencimento[2]}` : partesDataVencimento[2];
        fatura.dataVencimentoFormatada = `${partesDataVencimento[0]}/${meses[numeroMes - 1]}/${ano}`;
      }

      this.fatura  = fatura;
      this.faturaCarregadaParaAvisosAtualizacao = true;
      this.carregueAvisosAtualizacaoSePossivel();

      if( this.route.snapshot.queryParams['pagarcartao'] ){
            setTimeout(() => {
              this.faturaAberta.abraModalPagarCartao();
            }, 500)
      }
    }).catch(() => {
      this.faturaCarregadaParaAvisosAtualizacao = true;
      this.carregueAvisosAtualizacaoSePossivel();
    })
  }

  ngAfterViewInit() {  }

  ngOnDestroy() {
    if (this.inscricaoLojaFechada) this.inscricaoLojaFechada.unsubscribe();
    if (this.timerResumoHoje) this.timerResumoHoje.unsubscribe();
    if (this.timerOperacao) this.timerOperacao.unsubscribe();
    if (this.assinaturaMonitorador) this.assinaturaMonitorador.unsubscribe();
    if (this.timerLinkCopiado) clearTimeout(this.timerLinkCopiado);
  }

  private deveAbrirFilaSuporte(): boolean {
    return this.iframe &&
      Number(this.empresa && this.empresa.id) === 1 &&
      !!(this.usuario && (this.usuario.admin || this.usuario.superadmin));
  }

  atualizeTela() {
    this.contatoService.obtenhaUltimasAcoes().then( ultimasAcoes => {
      this.ultimasAcoes = ultimasAcoes;
    });
  }

  // ─────────────────────────── Cabeçalho ───────────────────────────

  get saudacao(): string {
    const hora = new Date().getHours();

    if (hora < 12) return 'Bom dia';
    if (hora < 18) return 'Boa tarde';

    return 'Boa noite';
  }

  get primeiroNome(): string {
    return String(this.usuario && this.usuario.nome || '').trim().split(' ')[0] || '';
  }

  /** "terça-feira, 9 de setembro" — sem depender de locale do moment. */
  get dataDeHoje(): string {
    try {
      const texto = new Date().toLocaleDateString('pt-BR', {weekday: 'long', day: 'numeric', month: 'long'});
      return texto.charAt(0).toUpperCase() + texto.slice(1);
    } catch (erro) {
      return '';
    }
  }

  // ──────────────────────── Estado da loja ────────────────────────

  /** Mesmo serviço que o menu usa para decidir se a loja está aberta. */
  private get servicoPrincipal(): any {
    return ((this.empresa && this.empresa.horariosDoServico) || [])[0];
  }

  get lojaRecebendoPedidos(): boolean {
    if (!this.empresa || this.empresa.fechadoTemporariamente) return false;

    const servico = this.servicoPrincipal;

    if (servico) return !!(servico.estaAberta && servico.estaRecebendoPedidos);

    return !!(this.empresa.estaAberta && this.empresa.estaRecebendoPedidos);
  }

  get estadoLoja(): 'aberta' | 'pausada' | 'fechada' {
    if (this.empresa && this.empresa.fechadoTemporariamente) return 'pausada';

    return this.lojaRecebendoPedidos ? 'aberta' : 'fechada';
  }

  get tituloEstadoLoja(): string {
    if (this.estadoLoja === 'pausada') return 'Pedidos pausados';
    if (this.estadoLoja === 'aberta') return 'Recebendo pedidos normalmente';

    return 'Loja fechada';
  }

  get detalheEstadoLoja(): string {
    const servico = this.servicoPrincipal;

    if (this.estadoLoja === 'pausada') {
      return this.empresa?.mensagemPausaProgramada || 'Pausada manualmente. Reabra para voltar a receber pedidos.';
    }

    if (this.estadoLoja === 'aberta') {
      const fechamento = this.horarioFechamento(servico) || '23:59';
      return `Cardápio aberto e visível para os clientes • Fechamento previsto para às ${fechamento}`;
    }

    return (servico && (servico.mensagemAbrirPedidos || servico.motivo)) || 'Fora do horário de funcionamento';
  }

  /** Horário "HH:MM" em que o turno em andamento termina, ou null fora dos turnos de hoje. */
  private horarioFechamento(servico: any): string | null {
    const agora = new Date();
    const minutosAgora = agora.getHours() * 60 + agora.getMinutes();
    const minutos = (hora: string) => Number(hora.substr(0, 2)) * 60 + Number(hora.substr(3, 2));

    for (const turno of ((servico && servico.horariosHoje) || [])) {
      if (!turno.funciona || !turno.horarioAbertura || !turno.horarioFechamento) continue;

      const abre = minutos(turno.horarioAbertura);
      let fecha = minutos(turno.horarioFechamento);

      if (fecha <= abre) fecha += 24 * 60; // vira a madrugada

      if (minutosAgora >= abre && minutosAgora < fecha) return turno.horarioFechamento.substr(0, 5);
    }

    return null;
  }

  get podeGerenciarLoja(): boolean {
    return RotaGuardClient.gerenciaLoja(this.usuario);
  }

  // ───────────────────────── Vendas por período ─────────────────────────

  private diaNoFiltro(data: Date): string {
    const doisDigitos = (numero: number) => (numero < 10 ? '0' : '') + numero;

    return `${data.getFullYear()}${doisDigitos(data.getMonth() + 1)}${doisDigitos(data.getDate())}`;
  }

  private get diaDeHojeNoFiltro(): string {
    return this.diaNoFiltro(new Date());
  }

  /** DD/MM/YYYY, o formato em que o resumo devolve as diárias. */
  private diaNoResumo(data: Date): string {
    const doisDigitos = (numero: number) => (numero < 10 ? '0' : '') + numero;

    return `${doisDigitos(data.getDate())}/${doisDigitos(data.getMonth() + 1)}/${data.getFullYear()}`;
  }

  private someDias(data: Date, dias: number): Date {
    const nova = new Date(data.getTime());
    nova.setDate(nova.getDate() + dias);
    return nova;
  }

  private diasEntre(inicio: Date, fim: Date): string[] {
    const dias: string[] = [];
    for (let data = new Date(inicio.getTime()); data <= fim; data = this.someDias(data, 1)) dias.push(this.diaNoResumo(data));
    return dias;
  }

  /**
   * Início e fim do período e do anterior equivalente. Só "hoje" corta o
   * anterior no relógio; os demais são dias inteiros contra dias inteiros.
   */
  private intervalosDoPeriodo(chave: PeriodoHome) {
    const agora = new Date();
    const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
    const horaAgora = agora.toTimeString().substr(0, 8);
    const f = (data: Date) => this.diaNoFiltro(data);

    switch (chave) {
      case 'ontem': {
        const ontem = this.someDias(hoje, -1), anteontem = this.someDias(hoje, -2);
        return {atual: {di: f(ontem), df: f(ontem)}, anterior: {di: f(anteontem), df: f(anteontem)},
          dias: this.diasEntre(ontem, ontem), diasAnterior: this.diasEntre(anteontem, anteontem), rotuloAnterior: 'vs. anteontem'};
      }
      case '7dias': {
        const inicio = this.someDias(hoje, -6);
        return {atual: {di: f(inicio), df: f(hoje)}, anterior: {di: f(this.someDias(hoje, -13)), df: f(this.someDias(hoje, -7))},
          dias: this.diasEntre(inicio, hoje), diasAnterior: this.diasEntre(this.someDias(hoje, -13), this.someDias(hoje, -7)),
          rotuloAnterior: 'vs. 7 dias anteriores'};
      }
      case '30dias': {
        const inicio = this.someDias(hoje, -29);
        return {atual: {di: f(inicio), df: f(hoje)}, anterior: {di: f(this.someDias(hoje, -59)), df: f(this.someDias(hoje, -30))},
          dias: this.diasEntre(inicio, hoje), diasAnterior: this.diasEntre(this.someDias(hoje, -59), this.someDias(hoje, -30)),
          rotuloAnterior: 'vs. 30 dias anteriores'};
      }
      case 'mes': {
        const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const inicioAnterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        const ultimoDiaAnterior = new Date(hoje.getFullYear(), hoje.getMonth(), 0).getDate();
        const fimAnterior = new Date(inicioAnterior.getFullYear(), inicioAnterior.getMonth(), Math.min(hoje.getDate(), ultimoDiaAnterior));
        return {atual: {di: f(inicio), df: f(hoje)}, anterior: {di: f(inicioAnterior), df: f(fimAnterior)},
          dias: this.diasEntre(inicio, hoje), diasAnterior: this.diasEntre(inicioAnterior, fimAnterior),
          rotuloAnterior: `vs. mês passado até o dia ${hoje.getDate()}`};
      }
      default: {
        const ontem = this.someDias(hoje, -1);
        return {atual: {di: f(hoje), df: f(hoje)}, anterior: {di: f(ontem), df: `${f(ontem)} ${horaAgora}`},
          dias: this.diasEntre(hoje, hoje), diasAnterior: this.diasEntre(ontem, ontem),
          rotuloAnterior: `vs. ontem até ${horaAgora.substr(0, 5)}`};
      }
    }
  }

  private dadosVazios(): DadosPeriodoHome {
    return {resumo: null, anterior: null, produtos: [], carregando: false, dias: [], diasAnterior: [], rotuloAnterior: '',
      horas: null, horasAnterior: null, operadores: [], formasDePagamento: []};
  }

  carreguePeriodo(chave: PeriodoHome, forcar = false) {
    if (!this.exibirFinanceiro) return;

    const dados = this.periodos[chave] || (this.periodos[chave] = this.dadosVazios());
    if (dados.carregando || (dados.resumo && !forcar)) return;

    const intervalos = this.intervalosDoPeriodo(chave);
    const filtro = {dl: '1', bl: '1', ms: '1'};
    const zeros = {qtde: 0, total: 0, ticketMedio: 0, taxaDeEntrega: 0};

    dados.carregando = true;
    dados.dias = intervalos.dias;
    dados.diasAnterior = intervalos.diasAnterior;
    dados.rotuloAnterior = intervalos.rotuloAnterior;

    // Três chamadas independentes de propósito: falhar no anterior só custa a
    // comparação, falhar nos produtos só custa a lista; o número principal fica.
    this.vendasPedidoService.obtenhaResumo({...filtro, ...intervalos.atual}).then( (resumo: any) => {
      dados.resumo = resumo || zeros;
      dados.carregando = false;
      if (chave === 'hoje') this.horaResumoHoje = new Date().toTimeString().substr(0, 5);
    }).catch( () => {
      dados.resumo = dados.resumo || zeros;
      dados.carregando = false;
    });

    this.vendasPedidoService.obtenhaResumo({...filtro, ...intervalos.anterior})
      .then( (resumo: any) => dados.anterior = resumo || null)
      .catch( () => dados.anterior = null);

    this.vendasPedidoService.obtenhaResumoPrudutos({...filtro, ...intervalos.atual})
      .then( (resumo: any) => dados.produtos = (resumo && resumo.produtos || []).slice(0, 8))
      .catch( () => dados.produtos = []);

    this.vendasPedidoService.obtenhaResumoOperadoresVendas({...filtro, ...intervalos.atual})
      .then( (resumo: any) => dados.operadores = (resumo && resumo.operadores) || [])
      .catch( () => dados.operadores = []);

    // Sem `agfp` o /vendas/resumo nem seleciona a forma de pagamento: toda linha
    // vem com nome nulo, o DTO agrupa em 'Todas' e descarta o grupo — a lista
    // chegava sempre vazia. Mesma receita da tela de relatório de vendas.
    this.vendasPedidoService.obtenhaResumo({...filtro, ...intervalos.atual, agfp: true})
      .then( (resumo: any) => dados.formasDePagamento = (resumo && resumo.formasDePagamento) || [])
      .catch( () => dados.formasDePagamento = []);

    // Um dia só se desenha por hora, contra o dia anterior INTEIRO (o comparativo
    // dos números corta no relógio; o gráfico mostra o dia todo de ontem).
    if (chave === 'hoje' || chave === 'ontem') {
      const diaAnterior = intervalos.anterior.di;
      const paraHoras = (resposta: any) => (resposta && resposta.horas || []).map((item: any) => Number(item.total) || 0);

      this.vendasPedidoService.obtenhaResumoHoras({...filtro, ...intervalos.atual})
        .then( (resposta: any) => dados.horas = paraHoras(resposta))
        .catch( () => dados.horas = null);
      this.vendasPedidoService.obtenhaResumoHoras({...filtro, di: diaAnterior, df: diaAnterior})
        .then( (resposta: any) => dados.horasAnterior = paraHoras(resposta))
        .catch( () => dados.horasAnterior = null);
    }
  }

  /** O timer chama aqui: recarrega hoje e, se for outro, o período em exibição. */
  carregueResumoHoje() {
    this.carreguePeriodo('hoje', true);
    if (this.filtroPeriodo !== 'hoje') this.carreguePeriodo(this.filtroPeriodo, true);
    if (this.filtroPeriodo === 'hoje' || this.filtroPeriodo === 'ontem') this.carreguePeriodo('7dias', true);
  }

  mudarFiltroPeriodo(periodo: PeriodoHome) {
    this.filtroPeriodo = periodo;
    this.carreguePeriodo(periodo);
    // O gráfico de um dia só não diz nada; hoje/ontem desenham os últimos 7 dias.
    if (periodo === 'hoje' || periodo === 'ontem') this.carreguePeriodo('7dias');
  }

  get periodoAtual(): DadosPeriodoHome {
    return this.periodos[this.filtroPeriodo] || this.dadosVazios();
  }

  get resumoExibicao(): any {
    return this.periodoAtual.resumo || {qtde: 0, total: 0, ticketMedio: 0, taxaDeEntrega: 0};
  }

  get carregandoPeriodoAtual(): boolean {
    return this.periodoAtual.carregando && !this.periodoAtual.resumo;
  }

  get descricaoPeriodo(): string {
    const mapa: {[chave: string]: string} = {
      hoje: 'Hoje', ontem: 'Ontem', '7dias': 'Últimos 7 dias', '30dias': 'Últimos 30 dias', mes: 'Este mês'
    };
    return mapa[this.filtroPeriodo] || '';
  }

  get comparativoPedidos(): ComparativoHome { return this.compare('qtde'); }
  get comparativoVendas(): ComparativoHome { return this.compare('totalComTaxa'); }
  get comparativoTicket(): ComparativoHome { return this.compare('ticketMedio'); }
  get comparativoTaxas(): ComparativoHome { return this.compare('taxaDeEntrega'); }

  /**
   * Um número solto não diz se o período está bom — precisa de um ponto de
   * apoio. Quando não dá para comparar (anterior zerado, atual sem venda), o
   * cartão mostra a referência em texto em vez de inventar uma variação.
   */
  private compare(metrica: 'qtde' | 'totalComTaxa' | 'ticketMedio' | 'taxaDeEntrega'): ComparativoHome {
    const dados = this.periodoAtual;
    const atual = Number(dados.resumo && dados.resumo[metrica]) || 0;
    const anterior = Number(dados.anterior && dados.anterior[metrica]) || 0;
    const rotulo = dados.rotuloAnterior;

    if (!dados.anterior) return {chip: '', tom: '', texto: ''};

    if (!atual) {
      if (!anterior) return {chip: '', tom: '', texto: `Sem venda ${rotulo.replace('vs. ', 'e ')}`};

      return {chip: '', tom: '', texto: `${rotulo.replace('vs. ', '').replace(/^\w/, (c) => c.toUpperCase())}: ${this.formateComparativo(metrica, anterior)}`};
    }

    if (!anterior) return {chip: '', tom: '', texto: `Sem base ${rotulo.replace('vs. ', 'em ')}`};

    const variacao = Math.round(((atual - anterior) / anterior) * 100);

    if (!variacao) return {chip: 'igual', tom: 'igual', texto: rotulo.replace('vs. ', 'a ')};

    return {
      chip: `${variacao > 0 ? '+' : ''}${variacao}%`,
      // Queda de venda é assunto do dia, não erro de sistema: âmbar, nunca o
      // vermelho que a tela reserva para pendência travada.
      tom: variacao > 0 ? 'alta' : 'baixa',
      texto: rotulo
    };
  }

  private formateComparativo(metrica: string, valor: number): string {
    if (metrica === 'qtde') return `${valor} ${valor === 1 ? 'pedido' : 'pedidos'}`;

    try {
      return `R$ ${valor.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
    } catch (erro) {
      return `R$ ${valor.toFixed(2).replace('.', ',')}`;
    }
  }

  // ── Gráfico de vendas ──

  private get ehPeriodoDeUmDia(): boolean {
    return this.filtroPeriodo === 'hoje' || this.filtroPeriodo === 'ontem';
  }

  /** Um dia desenha por hora. Se a série por hora falhar, cai nos últimos 7 dias. */
  get graficoPorHora(): boolean {
    return this.ehPeriodoDeUmDia && !!(this.periodoAtual.horas && this.periodoAtual.horas.length);
  }

  private get periodoDoGrafico(): DadosPeriodoHome {
    if (this.ehPeriodoDeUmDia && !this.graficoPorHora) return this.periodos['7dias'] || this.dadosVazios();
    return this.periodoAtual;
  }

  get legendaGrafico(): string {
    if (this.graficoPorHora) return `Faturamento por hora · ${this.descricaoPeriodo.toLowerCase()} contra o dia anterior`;
    if (this.ehPeriodoDeUmDia) return 'Faturamento por dia nos últimos 7 dias';
    return `Faturamento por dia · ${this.descricaoPeriodo.toLowerCase()} contra o período anterior`;
  }

  get rotulosVendas(): string[] {
    if (this.graficoPorHora) return Array.from({length: 24}, (ignorado: any, hora: number) => `${hora < 10 ? '0' : ''}${hora}h`);
    return this.periodoDoGrafico.dias.map((dia: string) => dia.substr(0, 5));
  }

  private serieDe(resumo: any, dias: string[]): number[] {
    const diarias: any[] = (resumo && resumo.diarias) || [];

    return dias.map((dia: string) => {
      const diaria = diarias.find((item: any) => item.dia === dia);
      return diaria ? Math.round((Number(diaria.totalComTaxa) || 0) * 100) / 100 : 0;
    });
  }

  get serieVendas(): number[] {
    if (this.graficoPorHora) return this.periodoAtual.horas;
    const dados = this.periodoDoGrafico;
    return this.serieDe(dados.resumo, dados.dias);
  }

  /**
   * Período anterior alinhado por posição (hora contra hora, dia 1 contra dia 1).
   * Mês contra mês pode ter tamanhos diferentes; o que sobra fica em branco.
   */
  get serieAnterior(): number[] {
    if (this.graficoPorHora) return this.periodoAtual.horasAnterior || [];
    const dados = this.periodoDoGrafico;
    const serie = this.serieDe(dados.anterior, dados.diasAnterior);

    return dados.dias.map((dia: string, indice: number) => (indice < serie.length ? serie[indice] : null));
  }

  get temSerieVendas(): boolean {
    return this.serieVendas.some((valor: number) => valor > 0) || this.temSerieAnterior;
  }

  get temSerieAnterior(): boolean {
    return this.serieAnterior.some((valor: number) => valor > 0);
  }

  get nomeSerieAtual(): string {
    const dados = this.periodoDoGrafico;
    if (this.graficoPorHora) return `${this.descricaoPeriodo} (${(dados.dias[0] || '').substr(0, 5)})`;
    if (this.ehPeriodoDeUmDia) return 'Últimos 7 dias';
    return this.descricaoPeriodo;
  }

  get nomeSerieAnterior(): string {
    const dados = this.periodoDoGrafico;
    if (this.graficoPorHora) return `${this.filtroPeriodo === 'hoje' ? 'Ontem' : 'Anteontem'} (${(dados.diasAnterior[0] || '').substr(0, 5)})`;
    return dados.rotuloAnterior.replace('vs. ', '').replace(/^\w/, (c) => c.toUpperCase());
  }

  get rotacaoRotulosVendas(): number {
    return this.rotulosVendas.length > 14 ? -60 : 0;
  }

  /** No celular, 24 horas viram rótulos de 3 em 3 e 30 dias de 5 em 5; no desktop, todos. */
  get passoRotulosVendas(): number {
    if (!this.isMobile) return 1;
    const total = this.rotulosVendas.length;
    if (total > 20) return this.graficoPorHora ? 3 : 5;
    if (total > 10) return 2;
    return 1;
  }

  mostrarGraficoNoCelular = false;
  /** No celular a lista de horas fica atrás de "ver números"; o padrão são as barras. */
  mostrarNumerosNoCelular = false;

  /**
   * A série em micro-barras. Hora e dia são baldes discretos: linha liga um
   * balde no outro e, num dia de uma venda só, vira um traço reto com um pico
   * — parece gráfico quebrado. Coluna mostra "vendeu nessa hora" e pronto.
   * Quem não vendeu fica como tiquinho cinza, para as 24 horas continuarem lá.
   */
  get barrasSerie(): Array<{rotulo: string, valor: number, altura: number, melhor: boolean}> {
    const serie = this.serieVendas || [], rotulos = this.rotulosVendas || [];
    const pico = Math.max(...serie.map((valor: number) => Number(valor) || 0), 0);
    const melhor = this.indiceMelhorPonto;

    return serie.map((valor: number, indice: number) => {
      const numero = Number(valor) || 0;

      return {
        rotulo: rotulos[indice] || '',
        valor: numero,
        altura: pico ? Math.max(Math.round((numero / pico) * 100), numero ? 6 : 0) : 0,
        melhor: indice === melhor
      };
    });
  }

  private get indiceMelhorPonto(): number {
    const serie = this.serieVendas || [];
    let indiceMelhor = -1, maior = 0;

    serie.forEach((valor: number, indice: number) => {
      const numero = Number(valor) || 0;
      if (numero > maior) { maior = numero; indiceMelhor = indice; }
    });

    return indiceMelhor;
  }

  /** A hora (ou o dia) que mais vendeu: a leitura que a lista de horas dava, em uma linha. */
  get melhorPontoSerie(): {rotulo: string, valor: number} | null {
    const indice = this.indiceMelhorPonto;

    if (indice < 0) return null;

    return {rotulo: (this.rotulosVendas || [])[indice] || '', valor: Number(this.serieVendas[indice]) || 0};
  }

  get rotuloMelhorPonto(): string {
    return this.graficoPorHora ? 'Melhor hora' : 'Melhor dia';
  }

  /** Volta do gráfico ou da lista para as barras. */
  voltarParaResumoDaSerie() {
    this.mostrarGraficoNoCelular = false;
    this.mostrarNumerosNoCelular = false;
  }

  /** Só as horas/dias com venda (atual ou anterior), para a leitura em lista no celular. */
  get serieCompacta(): Array<{rotulo: string, atual: number, anterior: number | null}> {
    const rotulos = this.rotulosVendas, atual = this.serieVendas, anterior = this.serieAnterior;

    return rotulos
      .map((rotulo: string, indice: number) => ({rotulo, atual: atual[indice] || 0, anterior: anterior[indice] === null || anterior[indice] === undefined ? null : (anterior[indice] || 0)}))
      .filter((linha) => linha.atual > 0 || (linha.anterior || 0) > 0);
  }

  // ── Balão do gráfico, desenhado por nós ──

  @ViewChild('graficoArea') graficoArea: ElementRef<HTMLElement>;

  /** Categoria sob o mouse, valores das duas séries e onde desenhar, relativo à área do gráfico. */
  balao: {categoria: string, diaAnterior: string, atual: number, anterior: number | null, x: number, y: number} | null = null;

  alterneValores(evento?: Event) {
    if (evento) { evento.stopPropagation(); evento.preventDefault(); }
    this.valoresOcultos = !this.valoresOcultos;
    if (this.valoresOcultos) this.balao = null;
    HomeV2Component.valoresReveladosNestaAbertura = !this.valoresOcultos;
  }

  /** "R$ 1.234,56", ou a máscara quando os valores estão ocultos. */
  moeda(valor: any): string {
    if (this.valoresOcultos) return 'R$ •••••';
    return formatCurrency(Number(valor) || 0, 'pt', 'R$');
  }

  /** Só o número ("1.234,56"), para os cartões que já trazem o "R$" à parte. */
  numero(valor: any): string {
    if (this.valoresOcultos) return '•••••';
    return formatNumber(Number(valor) || 0, 'pt', '1.2-2');
  }

  mostreBalao(evento: any) {
    if (this.valoresOcultos) { this.balao = null; return; }
    const categoria = evento && evento.category != null ? String(evento.category) : '';
    const indice = (this.rotulosVendas || []).indexOf(categoria);
    const area = this.graficoArea && this.graficoArea.nativeElement;
    const original = evento && evento.originalEvent;
    const mouse = original && (original.clientX != null ? original : original.originalEvent);

    if (indice < 0 || !area || !mouse || mouse.clientX == null) { this.balao = null; return; }

    const caixa = area.getBoundingClientRect();
    const larguraBalao = 200, alturaBalao = this.temSerieAnterior ? 78 : 56, afastamento = 14;
    let x = mouse.clientX - caixa.left + afastamento;
    let y = mouse.clientY - caixa.top - alturaBalao - 6;

    // Não deixa sair pela direita nem por cima da área.
    if (x + larguraBalao > caixa.width) x = mouse.clientX - caixa.left - afastamento - larguraBalao;
    if (y < 0) y = mouse.clientY - caixa.top + afastamento;

    const anterior = this.serieAnterior[indice];

    this.balao = {
      categoria,
      diaAnterior: this.diaAnteriorDe(categoria),
      atual: Number(this.serieVendas[indice]) || 0,
      anterior: anterior === null || anterior === undefined ? null : (Number(anterior) || 0),
      x: Math.max(0, Math.round(x)),
      y: Math.max(0, Math.round(y))
    };
  }

  escondaBalao() {
    this.balao = null;
  }

  /** Dia do período anterior que corresponde a um rótulo do eixo (DD/MM); vazio no gráfico por hora. */
  diaAnteriorDe(categoria: string): string {
    if (this.graficoPorHora) return '';
    const dados = this.periodoDoGrafico;
    const indice = dados.dias.findIndex((dia: string) => dia.substr(0, 5) === categoria);
    const dia = indice >= 0 ? dados.diasAnterior[indice] : '';

    return dia ? dia.substr(0, 5) : '';
  }

  // ── Composição do faturamento ──

  /**
   * De onde vem o número: produtos, mais as taxas cobradas do cliente, igual ao
   * total com taxas. Desconto aparece à parte porque já está abatido dos produtos.
   */
  get composicaoFaturamento(): ParcelaFaturamentoHome[] {
    const resumo = this.resumoExibicao;
    const n = (valor: any) => Number(valor) || 0;
    const parcelas: ParcelaFaturamentoHome[] = [
      {chave: 'produtos', rotulo: 'Produtos', valor: n(resumo.total), sinal: 'base', detalhe: 'valor dos itens, já com descontos'},
      {chave: 'entrega', rotulo: 'Taxas de entrega', valor: n(resumo.taxaDeEntrega), sinal: 'mais'},
      {chave: 'servico', rotulo: 'Taxa de serviço', valor: n(resumo.totalTaxaServico), sinal: 'mais'},
      {chave: 'pagamento', rotulo: 'Taxa da forma de pagamento', valor: n(resumo.totalTaxaFormaPagamento), sinal: 'mais', detalhe: 'cobrada do cliente'},
      {chave: 'total', rotulo: 'Total com taxas', valor: n(resumo.totalComTaxa) || n(resumo.total) + n(resumo.taxaDeEntrega) + n(resumo.totalTaxaServico) + n(resumo.totalTaxaFormaPagamento), sinal: 'igual'},
      {chave: 'descontos', rotulo: 'Descontos concedidos', valor: n(resumo.descontos), sinal: 'menos', detalhe: 'cupons e promoções, já abatidos'}
    ];

    return parcelas;
  }

  /**
   * Uma taxa zerada não merece uma linha inteira: só entram as parcelas que
   * existem no período, mais produtos e o total, que são sempre a leitura.
   */
  get composicaoComValor(): ParcelaFaturamentoHome[] {
    return this.composicaoFaturamento.filter((parcela: ParcelaFaturamentoHome) =>
      parcela.sinal === 'base' || parcela.sinal === 'igual' || parcela.valor > 0);
  }

  /** As parcelas que ficaram de fora, numa frase só — a informação não some. */
  get composicaoZerada(): string {
    const fora = this.composicaoFaturamento
      .filter((parcela: ParcelaFaturamentoHome) => parcela.sinal !== 'base' && parcela.sinal !== 'igual' && !parcela.valor)
      .map((parcela: ParcelaFaturamentoHome) => parcela.rotulo.toLowerCase());

    if (!fora.length) return '';

    return `Sem ${fora.join(', ').replace(/,\s([^,]*)$/, ' nem $1')} no período`;
  }

  /**
   * Barra empilhada do que soma no total: a proporção entre produtos e taxas
   * lida de uma vez, sem uma linha com ícone para cada parcela.
   */
  get segmentosComposicao(): Array<{chave: string, rotulo: string, pct: number}> {
    const somam = this.composicaoFaturamento.filter((parcela: ParcelaFaturamentoHome) =>
      (parcela.sinal === 'base' || parcela.sinal === 'mais') && parcela.valor > 0);
    const soma = somam.reduce((total: number, parcela: ParcelaFaturamentoHome) => total + parcela.valor, 0);

    if (!soma) return [];

    return somam.map((parcela: ParcelaFaturamentoHome) => ({
      chave: parcela.chave,
      rotulo: parcela.rotulo,
      pct: Math.round((parcela.valor / soma) * 1000) / 10
    }));
  }

  // ── Por onde vendi ──

  private distribuicao(lista: any[], nome: (item: any) => string): LinhaDistribuicaoHome[] {
    const linhas = (lista || [])
      .map((item: any) => {
        const total = Number(item.total) || 0, qtde = Number(item.qtde) || 0;
        return {nome: nome(item), total, qtde, ticket: qtde ? total / qtde : 0, fatia: 0};
      })
      .filter((linha: LinhaDistribuicaoHome) => linha.total > 0 || linha.qtde > 0)
      .sort((a: LinhaDistribuicaoHome, b: LinhaDistribuicaoHome) => b.total - a.total);
    const soma = linhas.reduce((acumulado: number, linha: LinhaDistribuicaoHome) => acumulado + linha.total, 0);

    linhas.forEach((linha: LinhaDistribuicaoHome) => linha.fatia = soma ? Math.round((linha.total / soma) * 100) : 0);

    return linhas.slice(0, 8);
  }

  private rotulo(mapa: {[chave: string]: string}, chave: any): string {
    const texto = String(chave || '').trim();
    if (mapa[texto]) return mapa[texto];
    if (!texto) return 'Outros';
    return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
  }

  get vendasPorPagamento(): LinhaDistribuicaoHome[] {
    return this.distribuicao(this.periodoAtual.formasDePagamento, (item: any) => this.rotulo({}, item.nome));
  }

  get vendasPorAtendimento(): LinhaDistribuicaoHome[] {
    const mapa = {delivery: 'Entrega', entrega: 'Entrega', retirada: 'Retirada', retirar: 'Retirada',
      mesa: 'Mesa', balcao: 'Balcão', Balcao: 'Balcão', outros: 'Outros'};
    const modalidades = this.resumoExibicao.vendasPorModalidadeAtendimento;

    if (modalidades && modalidades.length) return this.distribuicao(modalidades, (item: any) => this.rotulo(mapa, item.chave));

    return this.distribuicao(this.resumoExibicao.formasDeEntrega, (item: any) => this.rotulo(mapa, item.nome));
  }

  get vendasPorOrigem(): LinhaDistribuicaoHome[] {
    const mapa = {loja: 'Cardápio (link)', admin: 'Painel', bot: 'WhatsApp / Mia', garcom: 'Garçom', balcao: 'Balcão / PDV',
      ifood: 'iFood', keeta: 'Keeta', '99food': '99Food', opendelivery: 'OpenDelivery', totem: 'Totem', api: 'API', multiloja: 'Multiloja',
      CENTRAL_PEDIDOS: 'Central de pedidos', REPOSICAO_INTERNA: 'Reposição interna'};

    return this.distribuicao(this.resumoExibicao.vendasPorOrigemPedido, (item: any) => this.rotulo(mapa, item.chave));
  }

  get vendasPorFuncionario(): LinhaDistribuicaoHome[] {
    return this.distribuicao(this.periodoAtual.operadores, (item: any) => item.operador || 'Sem operador');
  }

  get dimensoesAnalise(): Array<{chave: DimensaoAnaliseHome, rotulo: string}> {
    return [
      {chave: 'pagamento', rotulo: 'forma de pagamento'},
      {chave: 'atendimento', rotulo: 'atendimento'},
      {chave: 'origem', rotulo: 'origem do pedido'},
      {chave: 'funcionario', rotulo: 'funcionário'}
    ];
  }

  get rotuloDimensaoAnalise(): string {
    const dimensao = this.dimensoesAnalise.find((item) => item.chave === this.dimensaoAnalise);
    return dimensao ? dimensao.rotulo.charAt(0).toUpperCase() + dimensao.rotulo.slice(1) : '';
  }

  get linhasAnalise(): LinhaDistribuicaoHome[] {
    switch (this.dimensaoAnalise) {
      case 'atendimento': return this.vendasPorAtendimento;
      case 'origem': return this.vendasPorOrigem;
      case 'funcionario': return this.vendasPorFuncionario;
      default: return this.vendasPorPagamento;
    }
  }

  get maisVendidos(): any[] {
    return this.periodoAtual.produtos || [];
  }

  get totalMaisVendidos(): number {
    return Number(this.resumoExibicao.total) || 0;
  }

  fatiaDoProduto(produto: any): number {
    const total = this.totalMaisVendidos;
    return total ? Math.round(((Number(produto && produto.total) || 0) / total) * 100) : 0;
  }

  identifiqueLinhaDistribuicao(indice: number, linha: LinhaDistribuicaoHome): string {
    return linha.nome;
  }

  /** Chegou pela escolha guardada, e não pelo link direto da prévia. */
  get escolheuHomeNova(): boolean {
    return this.preferenciaHome.usaHomeNova;
  }

  /**
   * Desfaz a escolha: o `/admin/index` volta a abrir a home antiga. Se já
   * estamos nela, o switch troca a tela sem navegar; o `navigateByUrl` cobre
   * quem chegou pelo link direto `/admin/index-v2`.
   */
  voltarParaHomeAnterior() {
    this.preferenciaHome.volteParaHomeAnterior();
    this.router.navigateByUrl('/admin/index').then(() => {});
  }

  abraRelatorioVendas() {
    this.router.navigateByUrl('/admin/financeiro-delivery-v2').then(() => {});
  }

  /**
   * A faixa se recarrega sozinha durante o turno; trocar os números por "—" a cada
   * duas horas de relógio piscaria a tela. Só a primeira carga mostra o vazio.
   */
  get carregandoPrimeiraVez(): boolean {
    return this.carregandoPeriodoAtual && !this.horaResumoHoje;
  }

  get exibirNumerosDeHoje(): boolean {
    return this.exibirFinanceiro && this.temModuloPedidos;
  }

  get exibirSecaoDesempenho(): boolean {
    return this.exibirFinanceiro && (this.temModuloPedidos || this.temModuloFidelidade);
  }

  get temAtalhos(): boolean {
    return !!(this.temModuloPedidos || (this.temModuloFidelidade && (this.temPermissaoAdicionarPontos || this.temPermissaoResgatarBrindes)));
  }

  get vendeuHoje(): boolean {
    const hoje = this.periodos['hoje'] && this.periodos['hoje'].resumo;
    return Number(hoje && hoje.qtde) > 0;
  }

  // ───────────────────────── Últimos pedidos ─────────────────────────
  // A pergunta que o lojista faz a cada dez minutos é "entrou pedido?", e a
  // resposta estava a uma tela de distância. A faixa aparece só quando existe
  // pedido: em loja sem movimento ela não vira um retângulo vazio do tamanho de
  // um cartão dizendo que nada aconteceu — quem diz isso é a linha do "Hoje".

  get exibirUltimosPedidos(): boolean {
    return this.temModuloPedidos && this.ultimosPedidos.length > 0;
  }

  carregueUltimosPedidos() {
    if (!this.temModuloPedidos || this.carregandoUltimosPedidos) return;

    this.carregandoUltimosPedidos = true;

    const filtro = {dia: this.diaDeHojeNoFiltro, orderByDesc: true};

    this.pedidosService.listePedidos(0, 6, filtro, EnumFiltroDePedidos.todos).then( (resposta: any) => {
      this.ultimosPedidos = (resposta && resposta.pedidos || []).slice(0, 6);
      this.carregandoUltimosPedidos = false;
    }).catch( () => {
      // Sem alarme: a faixa é conveniência, e o erro dela não pode roubar a tela.
      this.carregandoUltimosPedidos = false;
    });
  }

  /** O monitorador bate no servidor sozinho; só recarrego quando o placar dele muda. */
  private sincronizeUltimosPedidos() {
    const novos = (this.monitorador && this.monitorador.novosPedidos || []).length;

    if (novos === this.contagemNovosPedidos) return;

    this.contagemNovosPedidos = novos;
    this.carregueUltimosPedidos();
    this.carregueFilaAgora();
  }

  // ── Atualizar tudo (botão) ──

  atualizando = false;

  /** O botão recarrega o que muda durante o turno: fila, operação, últimos pedidos e o período em exibição. */
  atualizeTudo() {
    if (this.atualizando) return;

    this.atualizando = true;
    this.carregueFilaAgora();
    this.carregueUltimosPedidos();
    this.carregueCaixa();
    this.carregueMesas();
    if (this.exibirFinanceiro) this.carregueResumoHoje();

    // Sem esperar todas as respostas: o giro do ícone é feedback de clique, não de conclusão.
    setTimeout(() => this.atualizando = false, 1200);
  }

  // ── Fila agora ──

  carregueFilaAgora() {
    if (!this.temModuloPedidos || this.carregandoFila) return;

    this.carregandoFila = true;

    this.pedidosService.obtenhaResumoStatus().then( (fila: FilaAgoraHome) => {
      this.filaAgora = fila || null;
      this.carregandoFila = false;
    }).catch( () => {
      this.carregandoFila = false;
    });
  }

  /** As cinco células, sempre na mesma ordem: a posição vira memória muscular. */
  get celulasFila(): CelulaFilaHome[] {
    const fila = this.filaAgora || ({} as FilaAgoraHome);
    const n = (valor: any) => Number(valor) || 0;

    return [
      {id: 'novos', rotulo: 'Novos', acao: 'aceitar', nota: 'aguardando', quantidade: n(fila.novos), status: EnumStatusPedido.Novo, tom: 'novo'},
      {id: 'preparo', rotulo: 'Em preparo', acao: 'ver fila', nota: 'na cozinha', quantidade: n(fila.emPreparacao), status: EnumStatusPedido.EmPreparacao, tom: 'neutro'},
      {id: 'prontos', rotulo: 'Prontos', acao: 'despachar', nota: 'balcão/embalar', quantidade: n(fila.prontos), status: EnumStatusPedido.Pronto, tom: 'neutro'},
      {id: 'rua', rotulo: 'Na rua', acao: 'entregas', nota: 'em entrega', quantidade: n(fila.saiuParaEntrega), status: EnumStatusPedido.SaiuParaEntrega, tom: 'neutro'},
      {id: 'atrasados', rotulo: 'Atrasados', acao: 'ver', nota: '', quantidade: n(fila.atrasados), status: null, tom: 'atrasado'}
    ];
  }

  /**
   * As quatro etapas por onde o pedido passa. "Atrasados" é recorte de todas
   * elas, então sai da linha e vira aviso à parte — somar as cinco não fecha.
   */
  get etapasFila(): CelulaFilaHome[] {
    return this.celulasFila.filter((celula: CelulaFilaHome) => celula.tom !== 'atrasado');
  }

  get celulaAtrasados(): CelulaFilaHome | null {
    return this.celulasFila.find((celula: CelulaFilaHome) => celula.tom === 'atrasado') || null;
  }

  /** A explicação do que entra na contagem: fechada por padrão, a um toque no "i". */
  mostrarNotaFila = false;

  get horaFilaAgora(): string {
    const horario = this.filaAgora && this.filaAgora.horario;
    if (!horario) return '';
    const data = new Date(horario);
    return isNaN(data.getTime()) ? '' : data.toTimeString().substr(0, 5);
  }

  get toleranciaAtraso(): number {
    return (this.filaAgora && this.filaAgora.minutosTolerancia) || 60;
  }

  identifiqueCelulaFila(indice: number, celula: CelulaFilaHome): string {
    return celula.id;
  }

  abraCelulaFila(celula: CelulaFilaHome) {
    const extras = celula.status === null ? {} : {queryParams: {status: celula.status}};
    this.router.navigate(['/admin/pedidos'], extras).then(() => {});
  }

  // ── Operação (caixa e mesas) ──

  get exibirOperacao(): boolean {
    return this.exibirCaixaNaOperacao || this.exibirMesasNaOperacao;
  }

  get exibirCaixaNaOperacao(): boolean {
    return this.podeOperarCaixa && this.operacao.caixa !== undefined;
  }

  get exibirMesasNaOperacao(): boolean {
    return this.temModuloMesas && !!this.operacao.mesas;
  }

  carregueCaixa() {
    if (!this.podeOperarCaixa) return;

    this.caixaService.obtenhaCaixaAtual().then( (resposta: any) => {
      const caixa = resposta && resposta.caixa;
      this.operacao.caixa = caixa ? {
        aberto: true,
        desde: this.horaDoPedido({horario: caixa.horarioAbertura}),
        operador: caixa.operador && caixa.operador.nome ? String(caixa.operador.nome).split(' ')[0] : ''
      } : {aberto: false};
    }).catch( () => {
      // Sem caixa não é erro da tela: a linha simplesmente não aparece.
      this.operacao.caixa = undefined;
    });
  }

  carregueMesas() {
    if (!this.temModuloMesas) return;

    this.mesaService.obtenhaMesas(this.empresa).then( (mesas: any[]) => {
      const lista = (mesas || []).filter((mesa: any) => !mesa.removida);
      const ocupadas = lista.filter((mesa: any) => mesa.comandas && mesa.comandas.length);
      this.operacao.mesas = {
        total: lista.length,
        ocupadas: ocupadas.length,
        comandas: ocupadas.reduce((soma: number, mesa: any) => soma + mesa.comandas.length, 0)
      };
    }).catch( () => {
      this.operacao.mesas = null;
    });
  }

  abraCaixa() {
    this.router.navigateByUrl('/admin/meupdv').then(() => {});
  }

  /** Largura da barra de ocupação do salão, em %. */
  get ocupacaoMesas(): number {
    const mesas = this.operacao.mesas;
    if (!mesas || !mesas.total) return 0;
    return Math.min(100, Math.round((mesas.ocupadas / mesas.total) * 100));
  }

  abraMesas() {
    this.router.navigateByUrl('/admin/pedidos-mesas').then(() => {});
  }

  // ── Ordem dos blocos por perfil ──

  /** Quem vê vendas entra como dono; quem não vê, como operador. Só muda a ordem. */
  get ordemBlocos(): BlocoHome[] {
    if (this.contaNova) return this.exibirFinanceiro ? ORDEM_DONO_CONTA_NOVA : ORDEM_OPERADOR_CONTA_NOVA;

    return this.exibirFinanceiro ? ORDEM_DONO : ORDEM_OPERADOR;
  }

  /** Só depois que a fila respondeu: antes disso a ordem é a normal, para não pular. */
  get contaNova(): boolean {
    return !!this.filaAgora && this.filaAgora.jaVendeu === false;
  }

  identifiqueBloco(indice: number, bloco: BlocoHome): string {
    return bloco;
  }

  formaDeEntregaDoPedido(pedido: any): string {
    if (!pedido) return '';
    if (pedido.mesa) return 'Mesa';
    const forma = pedido.formaDeEntrega && (pedido.formaDeEntrega.nome || pedido.formaDeEntrega.descricao);
    return forma || (pedido.formaDeEntrega ? '' : 'Balcão');
  }

  horaDoPedido(pedido: any): string {
    const horario = pedido && (pedido.horario || pedido.data);

    if (!horario) return '';

    const data = new Date(horario);

    return isNaN(data.getTime()) ? '' : data.toTimeString().substr(0, 5);
  }

  clienteDoPedido(pedido: any): string {
    if (pedido && pedido.contato && pedido.contato.nome) return pedido.contato.nome;
    if (pedido && pedido.mesa) return `Mesa ${pedido.mesa.nome || pedido.mesa.numero || ''}`.trim();

    return 'Balcão';
  }

  statusDoPedido(pedido: any): string {
    return StatusPedidoLabel.get(Number(pedido && pedido.status)) || '';
  }

  ehPedidoNaoLido(pedido: any): boolean {
    const novos = (this.monitorador && this.monitorador.novosPedidos || []);

    return novos.some( (novo: any) => novo && pedido && novo.id === pedido.id);
  }

  identifiquePedido(indice: number, pedido: any) {
    return pedido && pedido.id;
  }

  /**
   * Direto na rota, sem passar pelo `verPedido` do monitorador: aquele zera o
   * contador de novos inteiro, e abrir um pedido da lista não é ter lido os seis.
   */
  abraPedido(pedido: any) {
    if (!pedido || !pedido.guid) return;

    this.router.navigateByUrl(`/admin/pedidos/detalhes/${pedido.guid}?t=${pedido.id}`, {state: pedido});
  }

  abraTodosOsPedidos() {
    this.router.navigateByUrl('/admin/pedidos');
  }

  // ─────────────────────── Pedidos e pendências ───────────────────────

  get novosPedidos(): number {
    return (this.monitorador && this.monitorador.novosPedidos || []).length;
  }

  /**
   * Só o que trava a operação; some da tela quando está tudo resolvido.
   * O getter roda a cada verificação de mudança, então a lista só é remontada
   * quando alguma contagem muda — senão o *ngFor recriaria os botões sem parar.
   */
  get pendencias(): PendenciaHome[] {
    const resumo = (this.monitorador && this.monitorador.resumoPedidos && this.monitorador.resumoPedidos.value) || {};
    const enderecosAlterados = (this.monitorador && this.monitorador.pedidosEnderecoAlterado || []).length;
    const assinatura = [resumo.totalPendenteOnline, resumo.totalErroParceiro, resumo.totalContestados,
      resumo.totalErrosImportar, enderecosAlterados].join('|');

    if (assinatura === this.assinaturaPendencias) return this.pendenciasEmCache;

    const monte = (id: string, quantidade: number, singular: string, plural: string, rota: string,
                   urgente: boolean): PendenciaHome =>
      ({id, quantidade, urgente, rota, texto: `${quantidade} ${quantidade === 1 ? singular : plural}`});

    const candidatas: PendenciaHome[] = [
      monte('onlineaguardando', Number(resumo.totalPendenteOnline) || 0,
        'pagamento online aguardando', 'pagamentos online aguardando', '/admin/pedidos/onlineaguardando', true),
      monte('erros', Number(resumo.totalErroParceiro) || 0,
        'pedido com erro no parceiro', 'pedidos com erro no parceiro', '/admin/pedidos/erros', true),
      monte('contestados', Number(resumo.totalContestados) || 0,
        'pedido contestado', 'pedidos contestados', '/admin/pedidos/contestados', true),
      monte('errosimportar', Number(resumo.totalErrosImportar) || 0,
        'falha ao importar pedido', 'falhas ao importar pedidos', '/admin/pedidos/errosimportar', false),
      monte('alteracaoendereco', enderecosAlterados,
        'endereço alterado pelo cliente', 'endereços alterados pelo cliente', '/admin/pedidos/alteracaoendereco', false)
    ];

    this.assinaturaPendencias = assinatura;
    this.pendenciasEmCache = candidatas.filter( (pendencia: PendenciaHome) => pendencia.quantidade > 0);

    return this.pendenciasEmCache;
  }

  identifiquePendencia(indice: number, pendencia: PendenciaHome): string {
    return pendencia.id;
  }

  abraPendencia(pendencia: PendenciaHome) {
    this.router.navigateByUrl(pendencia.rota).then( () => {});
  }

  abraPedidos() {
    this.router.navigateByUrl('/admin/pedidos').then( () => {});
  }

  get linkCardapio(): string {
    return (this.empresa && this.empresa.linkLoja) || 'https://fibo.meucardapio.ai';
  }

  /** O link sem protocolo, para caber no chip do banner. */
  get linkCardapioCurto(): string {
    return this.linkCardapio.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }

  @HostListener('document:keydown.escape')
  fecheQrCodePorTeclado() {
    if (this.mostrarQrCode) this.mostrarQrCode = false;
  }

  copieLinkDaLoja() {
    const link = this.linkCardapio;
    if (!link) return;

    this.escrevaNaAreaDeTransferencia(link).then(() => {
      this.linkCopiado = true;
      if (this.timerLinkCopiado) clearTimeout(this.timerLinkCopiado);
      this.timerLinkCopiado = setTimeout(() => this.linkCopiado = false, 2500);
    }).catch(() => {});
  }

  private escrevaNaAreaDeTransferencia(texto: string): Promise<void> {
    const area: any = navigator && (navigator as any).clipboard;

    if (area && area.writeText) return area.writeText(texto);

    return new Promise<void>((resolve, reject) => {
      const campo = document.createElement('textarea');
      campo.value = texto;
      campo.setAttribute('readonly', '');
      campo.style.position = 'fixed';
      campo.style.opacity = '0';
      document.body.appendChild(campo);
      campo.select();
      const copiou = document.execCommand('copy');
      document.body.removeChild(campo);
      if (copiou) resolve(); else reject();
    });
  }

  abraNovoPedido() {
    const rotaNovoPedido = obtenhaRotaNovoPedidoLocal();
    this.router.navigateByUrl(rotaNovoPedido + '?urlRetorno=' + location.pathname).then(() => {});
  }

  abraAcompanharPedidos() {
    this.router.navigateByUrl('/admin/pedidos').then(() => {});
  }

  openNovoCartao() {
    this.router.navigateByUrl('/admin/contatos/novo').then(() => {});
  }

  abraAdicionarPontos() {
    this.router.navigateByUrl('/admin/contatos/pontos/adicionar').then(() => {});
  }

  abraTrocarPontos() {
    this.router.navigateByUrl('/admin/contatos/pontos/trocar').then(() => {});
  }

  abraAcompanharMensagens() {
    this.router.navigateByUrl('/admin/mensagens').then(() => {});
  }

  simularPedido() {
    if (this.linkCardapio) {
      window.open(this.linkCardapio, '_blank');
    } else {
      this.abraNovoPedido();
    }
  }

  abrirConfiguracaoSom() {
    this.router.navigateByUrl('/admin/pedidos/configuracoes').then(() => {}).catch(() => {
      this.router.navigateByUrl('/admin/pedidos').then(() => {});
    });
  }

  abrirQrCodePreview() {
    window.open('/qrcode/qrcodeloja', '_blank');
  }

  get novosCartoesMes(): number {
    if (!this.resumo) return 0;
    return (this.resumo as any).novosMes || (this.resumo as any).novos || 0;
  }

  get temPermissaoAdicionarPontos(): boolean {
    if (!this.temModuloFidelidade) return false;
    return RotaGuardClient.adicionarPontosFidelidade(this.usuario || this.autorizacaoService.getUser());
  }

  get temPermissaoResgatarBrindes(): boolean {
    if (!this.temModuloFidelidade) return false;
    return RotaGuardClient.resgatarBrindesFidelidade(this.usuario || this.autorizacaoService.getUser());
  }


  exibaGraficoDia() {
    this.tipoGrafico = 'dia';
    this.vendasService.queryDia(this.seriesLabels, this.resumoVenda) ;
  }

  exibaGraficoMes() {
    this.tipoGrafico = 'mes';
    this.vendasService.queryMes(this.seriesLabels, this.resumoVenda) ;
  }

  exibaGraficoAno() {
    this.tipoGrafico = 'ano';
    this.vendasService.queryAno(this.seriesLabels, this.resumoVenda) ;
  }

  imprimaPedido(pedido: any) {
    window.open('/imprimir/pedido/' + pedido.guid);
  }

  fecheAterta() {
    this.fechouAlerta = true;
  }

  fecheModal() {
    this.exibirModal = true;
  }


  recarregue() {
    this.socketService.atualizeAbas();
  }

  sequence_operate(arr: any, index, fn){
    setTimeout(async () => {
      const objeto = arr[index];

      if( !objeto ) {
        return;
      }

      fn(objeto);
      this.sequence_operate(arr, index + 1, fn);
    }, 300);
  }

  adicionarTags() {
    this.marcando = true;
    this.contatoService.obtenhaContatosStatus().then( (contatos) => {
      window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: {
          tipo: 'ADICIONE_TAG',
          contatos: contatos
        }}, "*");
    }).catch( (erro) => {});
  }

  fecharAlertaStatus() {
    this.msgStatus = null;
  }

  notifique(msg: string) {
    this.msgStatus = this.sanitizer.bypassSecurityTrustHtml(msg);
  }


  cliqueAcessarCampanha(campanhaPendente: any) {
    this.router.navigate(['/admin/marketing'], {}).then(() => {
    });
  }

  /**
   * "Pausar loja" abre o modal novo da casca (fechar hoje / por intervalo /
   * agendar, com Keeta junto) — não mais o popup Kendo antigo de minutos.
   */
  fecharAgora() {
    this.casca.abraModalFecharLoja();
  }

  private atualizeBannerAposFechar(result: any) {
    if (!result || !result.fechou) return;

    this.empresa.estaRecebendoPedidos = false;
    this.empresa.fechadoTemporariamente = true;

    this.empresasService.logada().then( (_empresa: any) => {
      if (!_empresa) return;

      this.empresa.fechadoTemporariamente = _empresa.fechadoTemporariamente;
      this.empresa.mensagemPausaProgramada = _empresa.mensagemPausaProgramada;
      this.empresa.horariosDoServico = _empresa.horariosDoServico;
    }).catch( () => {});
  }

  reabrir() {
    if (this.reabrindoLoja) return;

    this.reabrindoLoja = true;

    this.empresasService.abra().then( () => {
      this.empresa.estaRecebendoPedidos = true;
      this.empresa.fechadoTemporariamente = false;
      delete this.empresa.mensagemPausaProgramada;

      return this.empresasService.logada();
    }).then( (_empresa: any) => {
      if (_empresa) {
        this.empresa.estaAberta = _empresa.estaAberta;
        this.empresa.estaRecebendoPedidos = _empresa.estaRecebendoPedidos;
        this.empresa.fechadoTemporariamente = _empresa.fechadoTemporariamente;
        this.empresa.horariosDoServico = _empresa.horariosDoServico;
      }

      this.reabrindoLoja = false;
    }).catch( () => {
      this.reabrindoLoja = false;
    });
  }


  // Detecta a mudança de tamanho da tela
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const largura = event.target.innerWidth;

    this.updateDialogWidth(largura);
    this.telaEstreita = this.isMobile || largura <= LARGURA_ESTREITA;
  }

  // Ajusta a largura do modal com base na largura da tela
  updateDialogWidth(width: number) {
    this.dialogWidth = width <= 768 ? '95%' : '700px';
  }

  get avisoAtualizacaoAtual(): AvisoAtualizacaoAtivoVM | null {
    return this.avisosAtualizacao[this.indiceAvisoAtualizacao] || null;
  }

  get primeiroAvisoAtualizacaoDisponivel(): AvisoAtualizacaoAtivoVM | null {
    return this.avisosAtualizacaoDisponiveis[0] || null;
  }

  get totalAvisosAtualizacao(): number {
    return this.avisosAtualizacao?.length || 0;
  }

  get totalAvisosAtualizacaoDisponiveis(): number {
    return this.avisosAtualizacaoDisponiveis?.length || 0;
  }

  get temAvisosAtualizacaoParaReabrir(): boolean {
    return this.totalAvisosAtualizacaoDisponiveis > 0;
  }

  get tituloCardAvisosPlataforma(): string {
    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Há avisos pendentes para revisão';
    }

    return this.totalAvisosAtualizacaoDisponiveis > 1
      ? `${this.totalAvisosAtualizacaoDisponiveis} avisos disponíveis`
      : '1 aviso disponível';
  }

  get descricaoCardAvisosPlataforma(): string {
    if (this.primeiroAvisoAtualizacaoDisponivel?.resumo) {
      return this.primeiroAvisoAtualizacaoDisponivel.resumo;
    }

    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Os avisos não abriram automaticamente porque havia outro modal prioritário no início.';
    }

    return 'Abra os avisos para revisar comunicados, atualizações e orientações da plataforma.';
  }

  get tituloCardAvisosAtualizacao(): string {
    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Há novidades pendentes para revisão';
    }

    return this.totalAvisosAtualizacaoDisponiveis > 1
      ? `${this.totalAvisosAtualizacaoDisponiveis} novidades disponíveis`
      : '1 novidade disponível';
  }

  get descricaoCardAvisosAtualizacao(): string {
    if (this.primeiroAvisoAtualizacaoDisponivel?.resumo) {
      return this.primeiroAvisoAtualizacaoDisponivel.resumo;
    }

    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Os avisos não abriram automaticamente porque havia outro modal prioritário no início.';
    }

    return 'Abra os avisos para revisar o que mudou recentemente na plataforma.';
  }

  get temAvisoAtualizacaoAnterior(): boolean {
    return this.indiceAvisoAtualizacao > 0;
  }

  get temProximoAvisoAtualizacao(): boolean {
    return this.indiceAvisoAtualizacao < this.totalAvisosAtualizacao - 1;
  }

  proximoAvisoAtualizacao(): void {
    const avisoAtual = this.avisoAtualizacaoAtual;
    if (!avisoAtual) {
      this.fecheModalAvisosAtualizacaoSemPersistencia();
      return;
    }

    this.registreConfirmacaoAvisoAtualizacao(avisoAtual);

    if (this.temProximoAvisoAtualizacao) {
      this.indiceAvisoAtualizacao += 1;
      this.registreVisualizacaoDoAvisoAtualizacao(this.avisoAtualizacaoAtual);
      return;
    }

    this.fecheModalAvisosAtualizacaoSemPersistencia();
  }

  avisoAtualizacaoAnterior(): void {
    if (!this.temAvisoAtualizacaoAnterior) {
      return;
    }

    this.indiceAvisoAtualizacao -= 1;
  }

  fecheModalAvisosAtualizacao(): void {
    this.adieAvisoAtualizacaoAtual();
  }

  verDepoisAvisoAtualizacao(): void {
    this.adieAvisoAtualizacaoAtual();
  }

  abrirAvisosAtualizacaoManualmente(): void {
    if (!this.temAvisosAtualizacaoParaReabrir) {
      return;
    }

    this.avisosAtualizacaoPendentesPorConflito = false;
    this.abraModalAvisosAtualizacao(this.avisosAtualizacaoDisponiveis);
  }

  fecheModalAvisosAtualizacaoSemPersistencia(): void {
    this.exibirModalAvisosAtualizacao = false;
  }

  private carregueAvisosAtualizacaoSePossivel(): void {
    if (this.carregandoAvisosAtualizacao || this.tentativaAutomaticaAvisosAtualizacao) {
      return;
    }

    if (!this.empresaCarregadaParaAvisosAtualizacao || !this.faturaCarregadaParaAvisosAtualizacao) {
      return;
    }

    this.tentativaAutomaticaAvisosAtualizacao = true;
    this.carregandoAvisosAtualizacao = true;

    this.avisosAtualizacaoService.obtenhaAtivos().then((avisos: AvisoAtualizacaoAtivoVM[]) => {
      this.carregandoAvisosAtualizacao = false;
      this.avisosAtualizacaoDisponiveis = avisos || [];
      const idsOcultosNaSessao = this.obtenhaIdsSessao(this.chaveSessaoAvisosAtualizacaoOcultos);
      const avisosFiltrados = (avisos || []).filter((aviso: AvisoAtualizacaoAtivoVM) => !idsOcultosNaSessao.includes(Number(aviso.id)));

      if (!avisosFiltrados.length) {
        this.avisosAtualizacaoPendentesPorConflito = false;
        return;
      }

      if (this.existeConflitoComModalDeAvisos()) {
        this.avisosAtualizacaoPendentesPorConflito = true;
        return;
      }

      setTimeout(() => {
        if (this.existeConflitoComModalDeAvisos()) {
          this.avisosAtualizacaoPendentesPorConflito = true;
          return;
        }

        this.abraModalAvisosAtualizacao(avisosFiltrados);
      }, 1200);
    }).catch(() => {
      this.carregandoAvisosAtualizacao = false;
    });
  }

  private existeConflitoComModalDeAvisos(): boolean {
    return !!(this.fatura && (this.fatura.vencida || this.fatura.venceHoje));
  }

  private abraModalAvisosAtualizacao(avisos: AvisoAtualizacaoAtivoVM[]): void {
    if (!avisos || !avisos.length) {
      return;
    }

    this.avisosAtualizacaoPendentesPorConflito = false;
    this.avisosAtualizacao = avisos.slice();
    this.indiceAvisoAtualizacao = 0;
    this.exibirModalAvisosAtualizacao = true;
    this.registreVisualizacaoDoAvisoAtualizacao(this.avisoAtualizacaoAtual);
  }

  obtenhaRotuloTipoAvisoAtualizacao(tipo: string): string {
    if (tipo === 'melhoria') return 'Melhoria';
    if (tipo === 'correcao') return 'Correção';
    if (tipo === 'importante') return 'Importante';
    return 'Novidade';
  }

  obtenhaClasseTipoAvisoAtualizacao(tipo: string): string {
    if (tipo === 'melhoria') return 'tipo-melhoria';
    if (tipo === 'correcao') return 'tipo-correcao';
    if (tipo === 'importante') return 'tipo-importante';
    return 'tipo-novidade';
  }

  obtenhaClassePrioridadeAvisoAtualizacao(prioridade: string): string {
    if (prioridade === 'alta') return 'prioridade-alta';
    if (prioridade === 'baixa') return 'prioridade-baixa';
    return 'prioridade-normal';
  }

  obtenhaIconeTipoAvisoAtualizacao(tipo: string): string {
    if (tipo === 'melhoria') return 'fa-lightbulb';
    if (tipo === 'correcao') return 'fa-cogs';
    if (tipo === 'importante') return 'fa-exclamation-circle';
    return 'fa-bullhorn';
  }

  obtenhaTextoPrioridadeAvisoAtualizacao(prioridade: string): string {
    if (prioridade === 'alta') return 'Prioridade alta';
    if (prioridade === 'baixa') return 'Prioridade baixa';
    return 'Prioridade normal';
  }

  obtenhaRotuloTipoAvisoPlataforma(tipo: string): string {
    if (tipo === 'melhoria') return 'Melhoria';
    if (tipo === 'correcao') return 'Correção';
    if (tipo === 'comunicado_operacional') return 'Comunicado operacional';
    if (tipo === 'indisponibilidade_suporte') return 'Indisponibilidade de suporte';
    if (tipo === 'manutencao') return 'Manutenção';
    if (tipo === 'importante') return 'Importante';
    return 'Novidade';
  }

  obtenhaClasseTipoAvisoPlataforma(tipo: string): string {
    if (tipo === 'melhoria') return 'tipo-melhoria';
    if (tipo === 'correcao') return 'tipo-correcao';
    if (tipo === 'comunicado_operacional') return 'tipo-comunicado-operacional';
    if (tipo === 'indisponibilidade_suporte') return 'tipo-indisponibilidade-suporte';
    if (tipo === 'manutencao') return 'tipo-manutencao';
    if (tipo === 'importante') return 'tipo-importante';
    return 'tipo-novidade';
  }

  obtenhaIconeTipoAvisoPlataforma(tipo: string): string {
    if (tipo === 'melhoria') return 'fa-lightbulb';
    if (tipo === 'correcao') return 'fa-cogs';
    if (tipo === 'comunicado_operacional') return 'fa-bullhorn';
    if (tipo === 'indisponibilidade_suporte') return 'fa-headset';
    if (tipo === 'manutencao') return 'fa-tools';
    if (tipo === 'importante') return 'fa-exclamation-circle';
    return 'fa-bullhorn';
  }

  obtenhaBlocosConteudoAvisoAtualizacao(conteudo: string): Array<{ tipo: 'paragrafo' | 'lista', itens: string[] }> {
    const blocos: Array<{ tipo: 'paragrafo' | 'lista', itens: string[] }> = [];
    const linhas = String(conteudo || '').split(/\r?\n/);
    let linhasParagrafo: string[] = [];
    let itensLista: string[] = [];

    const finalizeParagrafo = () => {
      const texto = linhasParagrafo.join(' ').trim();
      if (texto) {
        blocos.push({tipo: 'paragrafo', itens: [texto]});
      }
      linhasParagrafo = [];
    };

    const finalizeLista = () => {
      if (itensLista.length) {
        blocos.push({tipo: 'lista', itens: itensLista.slice()});
      }
      itensLista = [];
    };

    for (const linhaBruta of linhas) {
      const linha = String(linhaBruta || '').trim();

      if (!linha) {
        finalizeParagrafo();
        finalizeLista();
        continue;
      }

      if (/^([*\-•])\s+/.test(linha)) {
        finalizeParagrafo();
        itensLista.push(linha.replace(/^([*\-•])\s+/, '').trim());
        continue;
      }

      finalizeLista();
      linhasParagrafo.push(linha);
    }

    finalizeParagrafo();
    finalizeLista();

    return blocos;
  }

  private adieAvisoAtualizacaoAtual(): void {
    const avisoAtual = this.avisoAtualizacaoAtual;
    this.fecheModalAvisosAtualizacaoSemPersistencia();

    if (!avisoAtual) {
      return;
    }

    this.registreAdiamentoAvisoAtualizacao(avisoAtual);
  }

  private registreVisualizacaoDoAvisoAtualizacao(aviso: AvisoAtualizacaoAtivoVM | null): void {
    if (!aviso || this.existeIdNaSessao(this.chaveSessaoAvisosAtualizacaoVisualizados, aviso.id)) {
      return;
    }

    this.adicioneIdNaSessao(this.chaveSessaoAvisosAtualizacaoVisualizados, aviso.id);
    this.avisosAtualizacaoService.marqueVisualizado(aviso.id).catch(() => {});
  }

  private registreConfirmacaoAvisoAtualizacao(aviso: AvisoAtualizacaoAtivoVM): void {
    this.adicioneIdNaSessao(this.chaveSessaoAvisosAtualizacaoOcultos, aviso.id);
    this.avisosAtualizacaoService.marqueConfirmado(aviso.id).catch(() => {});
  }

  private registreAdiamentoAvisoAtualizacao(aviso: AvisoAtualizacaoAtivoVM): void {
    this.adicioneIdNaSessao(this.chaveSessaoAvisosAtualizacaoOcultos, aviso.id);
    this.avisosAtualizacaoService.marqueAdiado(aviso.id).catch(() => {});
  }

  private obtenhaIdsSessao(chave: string): number[] {
    try {
      const valor = sessionStorage.getItem(chave);
      if (!valor) {
        return [];
      }

      const ids = JSON.parse(valor);
      if (!Array.isArray(ids)) {
        return [];
      }

      return ids
        .map((item: any) => Number(item))
        .filter((item: number) => !Number.isNaN(item) && item > 0);
    } catch (erro) {
      return [];
    }
  }

  private existeIdNaSessao(chave: string, id: number): boolean {
    return this.obtenhaIdsSessao(chave).includes(Number(id));
  }

  private adicioneIdNaSessao(chave: string, id: number): void {
    try {
      const ids = this.obtenhaIdsSessao(chave);
      const idNormalizado = Number(id);

      if (!idNormalizado || ids.includes(idNormalizado)) {
        return;
      }

      ids.push(idNormalizado);
      sessionStorage.setItem(chave, JSON.stringify(ids));
    } catch (erro) {}
  }

}
